
































import { Vue, Component } from 'vue-property-decorator'
import PStorage from '@/util/PStorage'
import Locker from '@/util/Locker'

@Component({ name: 'account-dropdown' })
export default class Account extends Vue {
    get username(): string {
        return PStorage.get('username')
    }

    get image(): string {
        const id = Math.floor(Math.random() * 100)
        return `https://randomuser.me/api/portraits/women/${id}.jpg`
    }

    input(value: string): void {
        if (value === 'logout') {
            this.logout()
        }
        if (value === 'settings') {
            this.$router.push('/preferences')
        }
    }

    logout() {
        PStorage.remove('private_key')
        Locker.endInterval()
        Locker.run(this)
    }
}
